<template>
  <div :class="['pac-phone-input', 'w-full', { 'pac-phone-input--invalid': invalid }]">
    <input
      ref="phoneInput"
      type="tel"
      class="form-control pac-input"
      @input="onInput"
    />
  </div>
</template>

<script>
import intlTelInput from "intl-tel-input";
import "intl-tel-input/build/css/intlTelInput.css";

export default {
  name: "PacPhoneInput",
  props: ["value", "invalid"],
  data() {
    return {
      iti: null,
    };
  },
  mounted() {
    this.initIti();
  },
  methods: {
    initIti() {
      this.iti = intlTelInput(this.$refs.phoneInput, {
        initialCountry: "gh",
        separateDialCode: true,
        preferredCountries: ["gh", "ng", "gb", "us"],
        utilsScript:
          "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/js/utils.js",
        dropdownContainer: document.body,
      });

      if (this.value) {
        this.iti.setNumber(this.value);
      }
    },
    onInput() {
      const number = this.iti.getNumber();
      const isValid = this.iti.isValidNumber();
      this.$emit("input", number);
      this.$emit("validate", isValid);
    },
  },
  watch: {
    value(newVal) {
      if (this.iti && newVal !== this.iti.getNumber()) {
        this.iti.setNumber(newVal);
      }
    },
  },
  beforeDestroy() {
    if (this.iti) {
      this.iti.destroy();
    }
  },
};
</script>

<style lang="scss">
$neutral: #80A0AF;
$main-color: #011151;

.pac-phone-input {
  display: block;
  width: 100%;

  .iti {
    display: block;
    width: 100%;

    input.pac-input {
      width: 100%;
      padding-top: 1rem;
      padding-bottom: 1rem;
      line-height: 1.5;
      min-height: 45px;
      color: #80A0AF !important;
      background: #fff;
      border: 1px solid $neutral !important;
      border-radius: 5px !important;
      font-size: 0.875rem;

      &:focus {
        outline: none;
        border-color: $main-color !important;
        box-shadow: none !important;
      }

      &::placeholder {
        color: $neutral;
        opacity: 0.3;
      }
    }

    .iti__selected-flag {
      background: transparent;
      border-right: 1px solid $neutral;
      padding: 0 10px;
      border-radius: 5px 0 0 5px;
    }

    .iti__selected-dial-code {
      font-size: 0.85rem;
      color: $neutral;
      margin-left: 4px;
    }

    .iti__country-list {
      border-radius: 5px;
      box-shadow: 0 4px 16px rgba(0,0,0,0.12);
      border: 1px solid rgba(0,0,0,0.1);
      z-index: 9999;
    }
  }
}

.pac-phone-input--invalid .iti input.pac-input {
  border-color: #ea5455 !important;
}
</style>
